/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { DiagonalHatchDefProps } from './utils/types.ts'
import { useMode } from './utils/mode.tsx'

function DiagonalHatchDef(props: DiagonalHatchDefProps) {
    const { playerId, statName, color } = props
    const mode = useMode()

    return (
        <pattern
            id={`${mode}-diagonal-hatch-${playerId}-${statName}`}
            patternUnits="userSpaceOnUse"
            width="4"
            height="4"
        >
            <path
                d="M-1,1 l2,-2
                        M0,4 l4,-4
                        M3,5 l2,-2"
                style={{ stroke: color, strokeWidth: 1 }}
            />
        </pattern>
    )
}

export default DiagonalHatchDef
